import { render, staticRenderFns } from "./affiliateModal.vue?vue&type=template&id=8b14efae&scoped=true&"
import script from "./affiliateModal.vue?vue&type=script&lang=js&"
export * from "./affiliateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b14efae",
  null
  
)

export default component.exports